import {DEVICES, MOBILE_DEVICE_SCREEN_SIZE} from '../constants/constants';

function isMobileDevice() {
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
}

function isDesktopScreen() {
  return window.innerWidth > MOBILE_DEVICE_SCREEN_SIZE[DEVICES.DESKTOP];
}

function isMobileScreen() {
  return window.innerWidth <= MOBILE_DEVICE_SCREEN_SIZE[DEVICES.DESKTOP];
}

function isTabletScreen() {
  return window.innerWidth <= MOBILE_DEVICE_SCREEN_SIZE[DEVICES.TABLET];
}

function isPhoneScreen() {
  return window.innerWidth <= MOBILE_DEVICE_SCREEN_SIZE[DEVICES.PHONE];
}

function isMobileAppControl() {
  let urlParams = new URLSearchParams(window.location.search);
  let controlParams = urlParams.has('forMobileApp');
  return controlParams;
}

function isMobileDeviceOrScreen() {
  return isMobileDevice() || isMobileScreen();
}

export {
  isMobileDevice,
  isDesktopScreen,
  isMobileScreen,
  isTabletScreen,
  isPhoneScreen,
  isMobileDeviceOrScreen,
  isMobileAppControl
};



// WEBPACK FOOTER //
// ./src/common/agent/agentUtils.js